
import * as _m0 from "protobufjs/minimal";
import { withAuthRetry } from '../utils/authRetry';
import { ModifySectionRequest, ModifySectionResponse } from '../modifysection';
import { getServiceUrl } from '../utils/api';

export async function modifySection(
    request: ModifySectionRequest,
    accessToken: string,
    setAccessToken: (token: string | null) => void,
    logout: () => void
): Promise<ModifySectionResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const url = getServiceUrl('reviewservice', 'modifysection');

        const encodedRequest = ModifySectionRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const response = await fetch(url, {
            method: 'POST',
            headers,
            body: base64
        });
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): ModifySectionResponse => {
        return ModifySectionResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
